import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Raleway',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80
    }
  },
  boxTitle: {
    width: '80%',
    display: 'flex',
    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '1.5rem'
  },
  title: {
    fontSize: '1.5em',
    fontWeight: 700,
    color: '#00A88F',
    fontFamily: 'Roboto',
    '@media all and (max-width: 600px)': {
      fontSize: '1.3em'
    }
  },
  boxTitleFire: {
    marginLeft: '2%',
    width: '90%',
    display: 'flex',
    alignItems: 'flex-end'
  },
  boxSubtitle: {
    width: '80%',
    display: 'flex',
    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '0.5rem'
  },
  icon: {
    color: 'red',
    paddingBottom: '3px'
  },
  subTitle: {
    fontSize: '1em',
    fontFamily: 'Raleway'
  },
  mainBoxes: {
    width: '90%',
    display: 'flex',
    marginLeft: '5%',
    marginTop: '2%',
    paddingBottom: '2%',
    flexDirection: 'column'
  }, //
  boxes: {
    backgroundColor: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    marginTop: '3%',
    marginLeft: '5%',
    border: '1px solid #dbdbdb',
    padding: '2%',
    width: '80%',
    '&:hover': {
      borderWidth: '1px 1px 1px 3px',
      borderColor: '#dbdbdb #dbdbdb #dbdbdb #00A88F',
      cursor: 'pointer'
    }
  },
  description: {
    fontStyle: 'normal',
    marginTop: '1%'
  },
  button: {
    border: '2px solid #00A88F',
    borderRadius: '23px',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#00A88F',
    marginTop: '2%'
  },
  insideBox: {
    display: 'flex',
    alignItems: 'center'
  },
  iconBoxes: {
    marginRight: '1%',
    fontSize: '3rem',
    color: '#454545'
  },
  insideBoxText: {
    marginLeft: '1%'
  }
}))

export default useStyles
